export const drawerWidth = 200;
